'use strict';

class MysticView {
    constructor($scope, $http, $uibModal) {
        this.$scope = $scope;
        this.$http = $http;
        this.$uibModal = $uibModal;

        this.data = null;

        this.curorder = null;
        this.curdisciplines = [];
        this.curtalents = [];

        this.get();
    }

    get()
    {
        this.$http({
            url: "/api/mystic/get",
            method: "get"
        }).then(
            (resp) => {
                console.log(resp);
                this.data = resp.data;
                this.updatedata();
            },
            (err) => {
                console.log(err);
            }
        )
    }

    selectorder(order)
    {
        this.curorder = order;
        this.updatedata();
    }

    contains(haystack, needle)
    {
        return haystack.filter(e=>{ return e.name === needle.name; }).length > 0
    }

    selecttalent(talent)
    {
        if (this.curtalents.filter(e=>{ return e.name === talent.name; }).length > 0) {
            this.curtalents = this.curtalents.filter(obj => {return obj.name!==talent.name});
        }
        else
            this.curtalents.push(talent);

        this.updatedata();
    }

    selectdiscipline(dis)
    {
        if (this.contains(this.curdisciplines, dis)) {
            this.curdisciplines = this.curdisciplines.filter(obj => {return obj.name!==dis.name});
        }
        else
            this.curdisciplines.push(dis);

        this.updatedata();
    }

    updatedata()
    {
        this.current = {other:[],action:[],reaction:[],bonus:[], focus:[]};
        this.data.features.forEach(x=>{
            x.source = "Features";
            if(x.action === "other")
                this.current.other.push(x);
            else if(x.action === "action")
                this.current.action.push(x);
            else if (x.action === "bonus")
                this.current.bonus.push(x);
            else
                this.current.reaction.push(x);
        });

        this.curtalents.forEach(x=>{
            x.source="Talent";
            if(x.action === "other")
                this.current.other.push(x);
            else if(x.action === "action")
                this.current.action.push(x);
            else if (x.action === "bonus")
                this.current.bonus.push(x);
            else
                this.current.reaction.push(x);
        });

        if(this.curorder && this.curorder.features)
        this.curorder.features.forEach(
            x=>{
                x.source="Order of " + this.curorder.name;
                if(x.action === "other")
                    this.current.other.push(x);
                else if(x.action === "action")
                    this.current.action.push(x);
                else if (x.action === "bonus")
                    this.current.bonus.push(x);
                else
                    this.current.reaction.push(x);
            }
        );

        this.curdisciplines.forEach(d=>{
            this.current.focus.push(d.focus);
            d.actions.forEach(x=>{
                x.source = d.name;
                if(x.action === "other")
                    this.current.other.push(x);
                else if(x.action === "action")
                    this.current.action.push(x);
                else if (x.action === "bonus")
                    this.current.bonus.push(x);
                else
                    this.current.reaction.push(x);
            });
        })
    }

    open(feature) {
        return this.$uibModal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: '/feature.htt',
            controller: 'FeatureModalCtrl',
            controllerAs: '$ctrl',
            size: 'lg',
            resolve: {
                feature:
                    () => {
                        return feature;
                    }
            }
        });
    }
}

MysticView.$inject = ['$scope', '$http', '$uibModal'];
export {MysticView};